import React from 'react'

import { usePermissions } from '../../hooks/usePermissions'
import {
  PermissionFeature,
  useFeaturePermission,
} from './hooks/useFeaturePermission'

export interface PermissionsProps {
  feature: PermissionFeature
  isVisible?: boolean
  fallback?: React.ReactNode
  children: React.ReactNode
}

export const Permissions: React.FC<PermissionsProps> = ({
  feature,
  children,
  fallback = null,
  isVisible = true,
}) => {
  const { permissions } = usePermissions()
  const hasPermission = useFeaturePermission()

  if (!isVisible || !permissions) {
    return null
  }

  return hasPermission(feature) ? children : fallback
}
